import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getFirestore } from "firebase/firestore";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAv8VmZg5Ds9IZWy_0xw0cmejz-UouS0vg",
  authDomain: "poc-chatbot-bolofy.firebaseapp.com",
  projectId: "poc-chatbot-bolofy",
  storageBucket: "poc-chatbot-bolofy.firebasestorage.app",
  messagingSenderId: "573173776396",
  appId: "1:573173776396:web:c4d6eefdc34e883ada6e29",
  measurementId: "G-E00F461KLJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
export const db = getFirestore(app);

const vapidKey = "BIaia9rwojZHI-zzuhJqV3ZgjanW1HIqgQweabW8-FWTNuPVRnamX61BTXS7w4KnW7os0safvJNMKgrOXoJs_Tk";

export const generateToken = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            const token = await getToken(messaging, {
                vapidKey: vapidKey
            });
            console.log("FCM Token:", token);
            
            // Store token in localStorage for later use
            localStorage.setItem('fcmToken', token);
            
            return token;
        } else {
            console.log("Notification permission denied");
            return null;
        }
    } catch (error) {
        console.error("Error generating FCM token:", error);
        return null;
    }
};

// Handle foreground messages
export const onMessageListener = () => {
    return new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });
};

// Call this function when your app initializes
export const initializeNotifications = async () => {
    // Check if service worker is supported
    if ('serviceWorker' in navigator) {
        try {
            // Register service worker
            await navigator.serviceWorker.register('/firebase-messaging-sw.js');
            console.log("Service worker registered");
            
            // Generate FCM token
            await generateToken();
        } catch (error) {
            console.error("Service worker registration failed:", error);
        }
    } else {
        console.log("Service workers not supported");
    }
};

// Add this to your main app component to listen for foreground messages
export const setupMessageListener = (setNotification) => {
    onMessageListener()
        .then(payload => {
            const { title, body } = payload.notification;
            setNotification({ title, body });
        })
        .catch(err => console.log('Failed to receive foreground notification:', err));
};